"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 是否为函数
 * @param  {*} fn 对象
 * @return {Boolean}  是否函数
 */
var is_type_1 = require("./is-type");
exports.default = (function (value) {
    return is_type_1.default(value, 'Function');
});
//# sourceMappingURL=is-function.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-function.js
// module id = 97
// module chunks = 37